module.exports = __webpack_public_path__ + "img/icon-warning-regn-4.90823918.svg";